import React from 'react';

const EntityMatcherItem = ({
    rowIndex,
    value,
    isHighlighted,
    selectedValue,
    onHover,
    onSelect
}) => {
    const isSelected = value.id === selectedValue.id;

    const labelStyle = {
        fontSize: 14,
        fontWeight: 500,
        color: isSelected ? '#b2b2b2' : '#414141'
    };

    const handleMouseEnter = () => {
        typeof onHover === 'function' && onHover(rowIndex);
    };

    const handleMouseLeave = () => {
        typeof onHover === 'function' && onHover(-1);
    };

    const handleSelectClick = (event) => {
        typeof onSelect === 'function' && !isSelected && onSelect(value);
    };

    return (
        <div
            style={{
                display: 'flex',
                padding: '1.5% 10px',
                backgroundColor:
                    isHighlighted && !isSelected ? '#dcffff' : '#ffffff'
            }}
            onClick={handleSelectClick}
            onMouseOver={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <span style={labelStyle}>
                {value.name}
            </span>
        </div>
    );
};

export default EntityMatcherItem;
